import { LocationState } from "../../type/location-state";

export const clearSelectedLocationDispatch = (state: LocationState) => {
  state.selectedLocation = undefined;
};
